import React from "react";
import styled from "styled-components";

import { AnalogClock } from "@components/AnalogClock";

const DeviceContainer = styled.div`
  width: 1920px;
  height: 1080px;
  background: red;
`;

export default () => {
  return <AnalogClock />;
};
